// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");

function t_encode(encoder_value, encoder_pendingPlaceholder, v) {
  if (v.TAG === /* Resolved */0) {
    return [
            "Resolved",
            Curry._1(encoder_value, v._0)
          ];
  } else {
    return [
            "Pending",
            Curry._1(encoder_pendingPlaceholder, v._0)
          ];
  }
}

function t_decode(decoder_value, decoder_pendingPlaceholder, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Pending" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_pendingPlaceholder, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Pending */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Resolved" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_value, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Resolved */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(stringifyValue, stringifyPlaceholder, pval) {
  if (pval.TAG === /* Resolved */0) {
    return "Resolved(" + (Curry._1(stringifyValue, pval._0) + ")");
  } else {
    return "Pending(" + (Curry._1(stringifyPlaceholder, pval._0) + ")");
  }
}

function getResolvedExn(buildMsg, x) {
  if (x.TAG === /* Resolved */0) {
    return x._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected value to be resolved, not pending: " + Curry._1(buildMsg, x._0));
  }
}

function compare(compareResolvedValues, v1, v2) {
  if (v1.TAG === /* Resolved */0 && v2.TAG === /* Resolved */0) {
    if (Curry._2(compareResolvedValues, v1._0, v2._0)) {
      return /* ResolvedValuesAreEqual */0;
    } else {
      return /* ResolvedValuesAreNotEqual */1;
    }
  } else {
    return /* UnableToDetermineEqualityBecauseOneIsNotResolved */2;
  }
}

function t_encode$1(v) {
  switch (v.TAG | 0) {
    case /* OnWindowInfoFetched */0 :
        return [
                "OnWindowInfoFetched",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_encode(v._0)
              ];
    case /* OnTabInfoFetched */1 :
        return [
                "OnTabInfoFetched",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_encode(v._0)
              ];
    case /* OnTabInfoFetchedByUrl */2 :
        return [
                "OnTabInfoFetchedByUrl",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OnTabInfoFetched" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnTabInfoFetched */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "OnTabInfoFetchedByUrl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnTabInfoFetchedByUrl */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "OnWindowInfoFetched" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWindowInfoFetched */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(v) {
  switch (v.TAG | 0) {
    case /* OnWindowInfoFetched */0 :
        return "OnWindowInfoFetched(" + (String(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(v._0)) + ")");
    case /* OnTabInfoFetched */1 :
        return "OnTabInfoFetched(" + (String(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(v._0)) + ")");
    case /* OnTabInfoFetchedByUrl */2 :
        return "OnTabInfoFetchedByUrl(url=" + (v._0 + ")");
    
  }
}

var PendingPlaceholderForRecording = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.getResolvedExn = getResolvedExn;
exports.compare = compare;
exports.PendingPlaceholderForRecording = PendingPlaceholderForRecording;
/* Util-SmartcutsMacros Not a pure module */
